<template>
    <div class="collapse collapse-arrow rounded md:rounded-md mb-2.5 md:mb-8 collapse-open animate-pulse overflow-hidden">
        <div class="shine min-h-[2.5rem] pl-5 pb-0.5 pt-1.5 md:min-h-[3.125rem] relative rounded-b md:rounded-b-none" />

        <div class="collapse-content bg-white p-0">
            <div class="px-0 pt-4 pb-5 md:pt-5 md:pb-7 md:px-5 lg:px-8 flex-1 space-y-6 py-1">
                <slot name="content">
                    <div class=" shine rounded-lg " />
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                            <div class="col-span-2 shine rounded-lg " />
                            <div class="col-span-1 shine rounded-lg " />
                        </div>
                        <div class=" shine" />
                    </div>
                </slot>
                <div class="flex flex-row-reverse space-x-4 space-x-reverse">
                    <div class="w-20 col-span-2 shine rounded-lg " />
                    <div class="w-20 col-span-1 shine rounded-lg " />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

};
</script>
<style scoped lang="scss">
.collapse.collapse-open {
    overflow: hidden;
}
.collapse.collapse-open .collapse-content {
    overflow: hidden;
}
</style>
